import { memo } from 'react';
import ComponentText from '../components/text';

const Text = memo(ComponentText);

export default Text;
